const availableOptions = {
  WS: ["ws01", "ws02", "ws03"],
  FlCo: [
    "wo01",
    "wo02",
    "wo03",
    "con01",
    "con02",
    "con03",
    "car01",
    "car02",
    "car03",
  ],
  CeCo: [
    "wo01",
    "wo02",
    "wo03",
    "con01",
    "con02",
    "con03",
    "pl01",
    "pl02",
    "pl03",
  ],
  WaCo: [
    "wo01",
    "wo02",
    "wo03",
    "br01",
    "br02",
    "br03",
    "pl01",
    "pl02",
    "pl03",
  ],
  ChCo: ["gl", "bl", "brl", "bc"],
  SoCo: ["gl", "bl", "brl", "bc"],
  BlCo: ["wo", "dm", "lm"],
};

export const generateRandomConfiguration = (options = availableOptions) => {
  const configuration = {};

  for (const [key, choices] of Object.entries(options)) {
    if (!Array.isArray(choices) || choices.length === 0) continue;
    const randomIndex = Math.floor(Math.random() * choices.length);
    configuration[key] = choices[randomIndex];
  }
  return configuration;
};
